import React from "react";
import "./Privacy_Policy.css";


import Privacy_Policy_content from "./Privacy_Policy_content/Privacy_Policy_content";

function Privacy_Policy() {
  return (
    <>
      <section className="Terms_Conditions">        

        <Privacy_Policy_content />
      </section>
    </>
  );
}

export default Privacy_Policy;
